import React from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { ClassNameMap } from '@mui/styles/withStyles';

import { Box, Chip, Divider, Grid, GridSize, Typography } from '@mui/material';

import styles from './styles';

interface Props extends WithStyles<typeof styles> {
  classes: ClassNameMap<string>;
  gridSize?: GridSize;
  title: string;
  subTitle?: string;
  description?: string;
  muiIcon?: React.ReactElement;
  chipLabel?: string;
  icon?: string;
  statusIcon?: React.ReactElement;
  statusIconColour?: 'error' | 'warning' | 'success';
  small?: boolean;
  selected?: boolean;
  divider?: boolean;
  onClick?: () => void;
}

const SpecialityCard = ({
  classes,
  gridSize = 6,
  title,
  subTitle,
  description,
  muiIcon,
  icon,
  statusIcon,
  statusIconColour,
  chipLabel,
  small = false,
  selected = false,
  divider = false,
  onClick,
}: Props): React.ReactElement => {
  return (
    <Grid item xs={gridSize} zeroMinWidth>
      <Box
        sx={{ mb: divider ? 0 : 2 }}
        className={`${classes.root} ${!onClick ? classes.noHover : ''} ${small ? classes.small : ''} ${selected ? classes.selected : ''}`}
        onClick={onClick}>
        {!!icon && (
          <div className={classes.icon}>
            <img src={`data:image/svg+xml;base64,${btoa(icon)}`} alt="icon" />
          </div>
        )}
        {!!muiIcon && muiIcon}
        <div className={classes.titleContainer}>
          <Box display="flex" alignItems="center">
            <Typography ml={muiIcon ? 1 : 0} className={classes.title} variant={small ? 'h6' : 'h5'}>
              {title}
            </Typography>
            {chipLabel && <Chip sx={{ ml: 1 }} size="small" label={chipLabel} />}
          </Box>
          {subTitle && (
            <Typography className={classes.subTitle} variant="subtitle2" color="textSecondary">
              {subTitle}
            </Typography>
          )}
          {description && (
            <Typography ml={muiIcon ? 1 : 0} className={classes.description} variant="subtitle2" color="grey.600">
              {description}
            </Typography>
          )}
          {statusIcon && <div className={`${classes.status} ${statusIconColour ? classes[statusIconColour] : ''}`}>{statusIcon}</div>}
        </div>
      </Box>
      {divider && <Divider />}
    </Grid>
  );
};

export default withStyles(styles)(SpecialityCard);
